const CustomFormTranslations ={
  "rc-about-doc" : "About this Document",
  "rc-about-video" : "About This Video",
  "rc-list-header": "What You'll Learn"
};
export default CustomFormTranslations;